import mixpanel from 'mixpanel-browser';

// Initialize Mixpanel
// Replace 'YOUR_MIXPANEL_TOKEN' with actual token or env variable
// For dev/demo purposes, we can use a placeholder or check if env var exists
const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN || 'test_token';

// Optional first-party proxy host (e.g. https://what-to-binge.com/mp). When set,
// the SDK sends events to our own domain instead of api-js.mixpanel.com, which
// ad-blockers block by name (net::ERR_BLOCKED_BY_CLIENT). Caddy then forwards
// /mp/* -> Mixpanel. Leave unset to send directly.
const MIXPANEL_API_HOST = process.env.REACT_APP_MIXPANEL_API_HOST;

export const initAnalytics = () => {
    if (process.env.REACT_APP_MIXPANEL_TOKEN) {
        try {
            mixpanel.init(MIXPANEL_TOKEN, {
                debug: process.env.NODE_ENV !== 'production',
                track_pageview: true,
                persistence: 'localStorage',
                ignore_dnt: true, // Ignore DNT as it can also cause issues sometimes, but mainly we want the try-catch
                ...(MIXPANEL_API_HOST ? { api_host: MIXPANEL_API_HOST } : {}),
            });
        } catch (error) {
            console.warn('Mixpanel initialization failed or was blocked by client:', error);
        }
    } else {
        console.warn('Mixpanel Token not found. Analytics disabled.');
    }
};

export const trackEvent = (eventName, properties = {}) => {
    if (process.env.REACT_APP_MIXPANEL_TOKEN) {
        try {
            mixpanel.track(eventName, properties);
        } catch (error) {
            console.warn(`Mixpanel tracking blocked for event: ${eventName}`);
        }
    } else {
        if (process.env.NODE_ENV !== 'production') {
            console.log(`[Analytics] ${eventName}`, properties);
        }
    }
};

// The browser's Mixpanel distinct_id, forwarded to the backend so the unblockable
// server-side search event is attributed to the SAME user as the client events
// (instead of appearing as a separate anonymous person). Returns null if Mixpanel
// isn't initialised or is blocked.
export const getDistinctId = () => {
    if (!process.env.REACT_APP_MIXPANEL_TOKEN) return null;
    try {
        return mixpanel.get_distinct_id() || null;
    } catch (error) {
        return null;
    }
};

export const identifyUser = (distinctId) => {
    if (process.env.REACT_APP_MIXPANEL_TOKEN) {
        try {
            mixpanel.identify(distinctId);
        } catch (error) {
            console.warn('Mixpanel identify blocked');
        }
    }
};
